import React from 'react';
import { Navigate } from 'react-router-dom';
import { isNativeApp } from './utils/platform';

/** Marketing /help — native shells use in-app Support (#340). */
export function HelpRoute({ children, SuspenseWrap }) {
  if (isNativeApp()) {
    return <Navigate to="/app/support" replace />;
  }
  return <SuspenseWrap>{children}</SuspenseWrap>;
}

/** Public /known-issues — native shells use in-app route (#1564; was redirect loop to Support). */
export function KnownIssuesRoute({ children, SuspenseWrap }) {
  if (isNativeApp()) {
    return <Navigate to="/app/known-issues" replace />;
  }
  return <SuspenseWrap>{children}</SuspenseWrap>;
}
